import { createConsumer, fetchTokenFromHTML } from '@anycable/web';
import { startActionCableMonitor } from './monitoring';

let defaultActionCable;

const getDefaultAnyCable = () => {
  // use the token from the meta tag that is rendered in
  // app/views/layouts/application.html.erb. This token is used for
  // authentication with the ActionCable server.
  if (!defaultActionCable) {
    try {
      defaultActionCable = createConsumer({
        protocol: 'actioncable-v1-ext-json',
        protocolOptions: { pongs: true },
        tokenRefresher: fetchTokenFromHTML()
      });
      console.log('Created default AnyCable consumer with token from meta tag');
      startActionCableMonitor(defaultActionCable);
    } catch (error) {
      console.log('Error creating AnyCable consumer:', error);
    }
  }
  return defaultActionCable;
};

export const createAnyCable = tokenData => {
  try {
    let actionCable;
    const accessToken = typeof tokenData === 'string' ? tokenData : tokenData?.access_token;

    if (accessToken) {
      actionCable = createConsumer({
        auth: { token: accessToken, param: 'access_token' },
        protocol: 'actioncable-v1-ext-json',
        protocolOptions: { pongs: true }
      });
      console.log('Created ActionCable consumer with access token');
      startActionCableMonitor(actionCable);
    } else {
      console.log('Creating default ActionCable consumer without token');
      actionCable = getDefaultAnyCable();
    }
    return actionCable;
  } catch (error) {
    console.log('Error creating ActionCable consumer:', error);
    return null;
  }
};
